import React, { useEffect, useState } from 'react';
import { Box, Grid, LinearProgress, Typography, makeStyles, Dialog, DialogTitle, DialogContent, Button, Popover, IconButton } from '@material-ui/core'
import { Link } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import DataService from "../../../../../Service";
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const columns = [
    { id: 'invoice_name', label: 'Tranche' },
    { id: 'amount', label: 'Amount' },
    { id: 'invoice_date', label: 'Invoice date' },
    { id: 'due_date', label: 'Due date' },
    { id: 'paid_date', label: 'Paid date' },
    { id: 'status', label: 'Status' },
];

// function createData(Tranche, Amount, Invoice, Due, Paid, Status) {
//     // const density = population / size;
//     return { Tranche, Amount, Invoice, Due, Paid, Status };
// }

// const rows = [
//     createData('Tranche 1', 'USD 7,125.00', '25/02/2020', '25/02/2020', '25/02/2020', 'paid'),
//     createData('Tranche 2', 'USD 7,125.00', '25/02/2020', '25/02/2020', '25/02/2020', 'paid'),
//     createData('Tranche 3', 'USD 7,125.00', '25/02/2020', '25/02/2020', '25/02/2020', 'paid'),
//     createData('Tranche 4', 'USD 7,125.00', '25/02/2020', '25/02/2020', '25/02/2020', 'paid'),
//     createData('Tranche 5', 'USD 7,125.00', '25/02/2020', '25/02/2020', '25/02/2020', 'paid'),
// ];

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    childContainer: {
        width: "50%", margin: "10px",
    },
    table: {
        width: "100%", border: "1px solid #E2E2E3"
    },
    actionButtons: {
        paddingTop: "35px",
        textAlign: "center",
        "& button": {
            marginRight: "20px",
        },
    },
});

const Costs = (props) => {
    const { id } = props
    const [costList, setCostList] = useState([]);

    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [open, setOpen] = React.useState(false);

    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 350,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }))(Tooltip);

    useEffect(() => {
        fetchCost()
    }, [])

    const fetchCost = () => {
        DataService.getData({ assignment_id: id }, 'fetch_cost').then((res) => {
            if (res?.success) {
                setCostList(res);
            }
        }).catch((error) => console.log(error))
    }

    const clientRows = costList?.client_invoices || [];
    const supplierRows = costList?.supplier_invoices || [];
     const globaluserData = useSelector((state) => state.commonReducer);
     let userRole = globaluserData.role;
// const userRole = sessionStorage.getItem("role");
const [cancellationModalOpen,setCancellationModelOpen]=useState(false);
const [anchorEl,setAnchorEl]=useState(null);
const cancellationTermsModalHandler = (event,action) =>{
    if(action==="open"){
        setAnchorEl(event.currentTarget);
        setCancellationModelOpen(true)
    }
    if(action==="close"){
        setCancellationModelOpen(false);
    }
}
    return <Box py={3}>
        <Grid container direction="column">
            <Grid item xs={6}>
                <Box  borderRadius={10} px={3} py={2} my={2}>
                    <Grid container direction="row" style={{ display: "flex", alignItems: "center" }}>
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" style={{ color: "#232323",fontWeight:"bold" }}>
                                <Box textAlign="left" fontWeight="fontWeightBold">Total Price</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1" style={{ color: "#232323" , fontWeight:"bold"}}>
                                <Box textAlign="right" fontWeight="fontWeightBold">{costList?.total_price || "-"}</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: "25px" }}>
                    {userRole!=="partner" && <div className={classes.childContainer}>
                        <Typography variant="subtitle1" style={{ textTransform: "capitalize" }} >
                            <Box sx={{ fontWeight: 'bold' }} color={"#ef7000"}>Client invoices</Box>
                        </Typography>
                        <Box className={classes.table}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {clientRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell key={column.id}>
                                                                {["invoice_date", "due_date", "paid_date"].includes(column.id) ? value ? moment(value).format("DD/MM/YYYY") : "N/A" : column.id === "status" ? <Typography variant="h2" style={{ color: row?.color_code }} >{value}</Typography> : value}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>}
                    {userRole !== "employee" && <div className={classes.childContainer}>
                        <Typography variant="subtitle1" style={{ textTransform: "capitalize" }} >
                            <Box sx={{ fontWeight: 'bold' }} color={"#ef7000"}>Supplier invoices</Box>
                        </Typography>
                        <Box className={classes.table}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {supplierRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell key={column.id}>
                                                                {["invoice_date", "due_date", "paid_date"].includes(column.id) ? value ? moment(value).format("DD/MM/YYYY") : "N/A" : column.id === "status" ? <Typography variant="h2" style={{ color: row?.color_code }} >{value}</Typography> : value}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>}
                </Box>
            </Grid>
            <Grid item xs={6} style={{ margin: "10px" }}>
                <Box >
                    <Grid container direction="row">
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" style={{ color: "#232323" }}>
                                <Box textAlign="left" fontWeight="fontWeightBold">Cancellation details</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1" onClick={(event)=>{cancellationTermsModalHandler(event,"open")}}  style={{color: "#EF7000", verticalAlign: "top",cursor:"pointer" ,marginRight: 10,textDecoration:"underline" }}>
                                View cancellation terms
                            </Typography>
                            { <Popover open={cancellationModalOpen} onClose={(event)=>{cancellationTermsModalHandler(event,"close")}} style={{maxHeight:"30rem"}} PaperProps={{style:{maxWidth:"30rem",minWidth:"20rem"}}} anchorEl={anchorEl} anchorOrigin={{vertical: 'top',horizontal: 'right',}}>
                                     <div style={{padding:"1rem",position:"relative"}}>
                                     <IconButton style={{position:"absolute",top:0.5,right:0.5}} onClick={(event)=>{cancellationTermsModalHandler(event,"close")}}><CloseIcon/></IconButton>
                                                <div>
                                                <p style={{fontWeight:"bold"}}>Program cancellation terms</p>
                                                {userRole!=="partner"&&<>
                                                {userRole==="admin"&&<p style={{marginLeft:"10px",fontWeight:"600"}}>Client</p>}
                                                <ul style={{ padding: "0px 25px" }}>{
                                                    costList?.client_pgm_cancellation_term?.length ? costList?.client_pgm_cancellation_term?.filter(el=>el!=="").map((item) => <li>{item}</li>) : "N/A"
                                                }</ul></>}
                                                {userRole !=="employee"&&<>
                                               {userRole==="admin"&& <p style={{marginLeft:"10px",fontWeight:"600"}}>Supplier</p>}
                                                <ul style={{ padding: "0px 25px" }}>{
                                                    costList?.supplier_pgm_cancellation_term?.length ? costList?.supplier_pgm_cancellation_term?.filter(el=>el!=="").map((item) => <li>{item}</li>) : "N/A"
                                                }</ul>
                                                </>}
                                                </div>

                                               <div> <p style={{fontWeight:"bold"}}>Session cancellation terms</p>
                                               {userRole!=="partner"&&<>
                                               {userRole==="admin"&&<p style={{marginLeft:"10px",fontWeight:"600"}}>Client</p>}
                                                <ul style={{ padding: "0px 25px" }}>{
                                                    costList?.client_session_cancellation_term?.length ? costList?.client_session_cancellation_term?.filter(el=>el!=="").map((item) => <li>{item}</li>) : "N/A"
                                                }</ul></>}
                                               {userRole !=="employee"&& <>
                                               {userRole==="admin"&& <p style={{marginLeft:"10px",fontWeight:"600"}}>Supplier</p>}
                                                <ul style={{ padding: "0px 25px" }}>{
                                                    costList?.supplier_session_cancellation_term?.length ? costList?.supplier_session_cancellation_term?.filter(el=>el!=="").map((item) => <li>{item}</li>) : "N/A"
                                                }</ul></>}
                                                </div>
                                               <div> <p style={{fontWeight:"bold"}}>360 cancellation terms</p>
                                               {userRole!=="partner"&&<>
                                               {userRole==="admin"&&<p style={{marginLeft:"10px",fontWeight:"600"}}>Client</p>}
                                                <ul style={{ padding: "0px 25px" }}>{
                                                    costList?.client_cancellation_term360?.length ? costList?.client_cancellation_term360?.filter(el=>el!=="").map((item) => <li>{item}</li>) : "N/A"
                                                }</ul></>}
                                                {userRole !=="employee"&&<>
                                                {userRole==="admin"&& <p style={{marginLeft:"10px",fontWeight:"600"}}>Supplier</p>}
                                                <ul style={{ padding: "0px 25px" }}>{
                                                    costList?.supplier_cancellation_term360?.length ? costList?.supplier_cancellation_term360?.filter(el=>el!=="").map((item) => <li>{item}</li>) : "N/A"
                                                }</ul></>}
                                                </div>
                                            </div>
                                </Popover>}
                        </Grid>
                    </Grid>
                </Box>
                <Box >
                    <Grid container direction="row">
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" style={{ color: "#707070" }}>
                                <Box textAlign="left" mt={2} >Cancellation Reason</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h2" style={{ color: "#232323" }}>
                                <Box textAlign="left">{costList?.cancellation_reason || "-"}</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box >
                    <Grid container direction="row">
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" style={{ color: "#707070" }}>
                                <Box textAlign="left" mt={2} >Cancellation notes</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h2" style={{ color: "#232323" }}>
                                <Box textAlign="left">{costList?.other_cancellation_reason || "-"}</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box >
                    <Grid container direction="row">
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" style={{ color: "#707070" }}>
                                <Box textAlign="left" mt={2} >Additional notes</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h2" style={{ color: "#232323" }}>
                                <Box textAlign="left">{costList?.additional_notes || "-"}</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    </Box>
}

export default Costs
